import React from 'react';
import { NavLink } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import './Sidebar.css';
import logo from '../../assets/images/logo.png'

interface SidebarProps {
  isCollapsed: boolean;
  onToggle: () => void;
}

const Sidebar: React.FC<SidebarProps> = ({ isCollapsed, onToggle }) => {
  const { t } = useTranslation();

  const navigationItems = [
    {
      path: '/dashboard',
      icon: (
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
          <rect x="3" y="3" width="7" height="7" />
          <rect x="14" y="3" width="7" height="7" />
          <rect x="14" y="14" width="7" height="7" />
          <rect x="3" y="14" width="7" height="7" />
        </svg>
      ),
      label: t('navigation.dashboard'),
      exact: true
    },
    {
      path: '/products',
      icon: (
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
          <path d="M6 2L3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4z" />
          <line x1="3" y1="6" x2="21" y2="6" />
          <path d="M16 10a4 4 0 0 1-8 0" />
        </svg>
      ),
      label: t('navigation.products')
    },
    {
      path: '/categories',
      icon: (
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
          <path d="M12 2L2 7v10c0 5.55 3.84 10 9 11 5.16-1 9-5.45 9-11V7z" />
          <path d="M8 11l2 2 4-4" />
        </svg>
      ),
      label: t('navigation.categories')
    },
    {
      path: '/sliders',
      icon: (
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
          <rect x="2" y="3" width="20" height="14" rx="2" />
          <line x1="8" y1="21" x2="16" y2="21" />
          <line x1="12" y1="17" x2="12" y2="21" />
        </svg>
      ),
      label: t('navigation.sliders')
    },
    // {
    //   path: '/messages',
    //   icon: (
    //     <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
    //       <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z" />
    //       <polyline points="22,6 12,13 2,6" />
    //     </svg>
    //   ),
    //   label: t('navigation.messages'),
    //   badge: 3 // Mock unread messages count
    // }
  ];

  // const settingsItems = [
  //   {
  //     path: '/settings',
  //     icon: (
  //       <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
  //         <circle cx="12" cy="12" r="3" />
  //         <path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 0 1 0 2.83 2 2 0 0 1-2.83 0l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-2 2 2 2 0 0 1-2-2v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 0 1-2.83 0 2 2 0 0 1 0-2.83l.06-.06a1.65 1.65 0 0 0 .33-1.82 1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1-2-2 2 2 0 0 1 2-2h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 0 1 0-2.83 2 2 0 0 1 2.83 0l.06.06a1.65 1.65 0 0 0 1.82.33H9a1.65 1.65 0 0 0 1 1.51V3a2 2 0 0 1 2-2 2 2 0 0 1 2 2v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 0 1 2.83 0 2 2 0 0 1 0 2.83l-.06.06a1.65 1.65 0 0 0-.33 1.82V9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 2 2 2 2 0 0 1-2 2h-.09a1.65 1.65 0 0 0-1.51 1z" />
  //       </svg>
  //     ),
  //     label: t('navigation.settings')
  //   }
  // ];

  return (
    <aside className={`sidebar ${isCollapsed ? 'sidebar--collapsed' : ''}`}>
      <div className="sidebar__header">
        <div className="sidebar__logo">
          <div className="sidebar__logo-icon">
            <img
              src={logo}
              alt="Dawaak Logo"
              width="32"
              height="32"
              style={{ borderRadius: '50%' }}
              onError={(e) => {
                // Fallback to a simple SVG if PNG is not found
                e.currentTarget.style.display = 'none';
                e.currentTarget.nextElementSibling?.setAttribute('style', 'display: block');
              }}
            />
            {/* Fallback SVG - simple medical cross */}
            <svg
              width="32"
              height="32"
              viewBox="0 0 24 24"
              fill="none"
              style={{ display: 'none' }}
            >
              <circle cx="12" cy="12" r="10" fill="#4A90E2" />
              <rect x="11" y="7" width="2" height="10" fill="white" />
              <rect x="7" y="11" width="10" height="2" fill="white" />
            </svg>
          </div>
          {!isCollapsed && (
            <div className="sidebar__logo-text">
              <h1>Dawaak</h1>
              <span>CMS</span>
            </div>
          )}
        </div>

        {/* <button
          className="sidebar__toggle"
          // onClick={onToggle}
          aria-label={isCollapsed ? 'Expand sidebar' : 'Collapse sidebar'}
        >
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <line x1="3" y1="6" x2="21" y2="6" />
            <line x1="3" y1="12" x2="21" y2="12" />
            <line x1="3" y1="18" x2="21" y2="18" />
          </svg>
        </button> */}
      </div>

      <nav className="sidebar__nav">
        <div className="sidebar__nav-section">
          <ul className="sidebar__nav-list">
            {navigationItems.map((item) => (
              <li key={item.path} className="sidebar__nav-item">
                <NavLink
                  to={item.path}
                  className={({ isActive }) =>
                    `sidebar__nav-link ${isActive ? 'sidebar__nav-link--active' : ''}`
                  }
                  end={item.exact}
                >
                  <span className="sidebar__nav-icon">
                    {item.icon}
                  </span>
                  {!isCollapsed && (
                    <>
                      <span className="sidebar__nav-text">
                        {item.label}
                      </span>
                      {/* {item.badge && (
                        <span className="sidebar__nav-badge">
                          {item.badge}
                        </span>
                      )} */}
                    </>
                  )}
                </NavLink>
                {/* {isCollapsed && item.badge && (
                  <div className="sidebar__nav-badge-collapsed">
                    {item.badge}
                  </div>
                )} */}
              </li>
            ))}
          </ul>
        </div>

        {/* <div className="sidebar__nav-section sidebar__nav-section--bottom">
          <ul className="sidebar__nav-list">
            {settingsItems.map((item) => (
              <li key={item.path} className="sidebar__nav-item">
                <NavLink
                  to={item.path}
                  className={({ isActive }) =>
                    `sidebar__nav-link ${isActive ? 'sidebar__nav-link--active' : ''}`
                  }
                >
                  <span className="sidebar__nav-icon">
                    {item.icon}
                  </span>
                  {!isCollapsed && (
                    <span className="sidebar__nav-text">
                      {item.label}
                    </span>
                  )}
                </NavLink>
              </li>
            ))}
          </ul>
        </div> */}
      </nav>
    </aside>
  );
};

export default Sidebar;